import React from "react";
import ReportViewPage from "./report-view-page/report-view-page";
import ReportComponents from "./report-components/report-components";
import s from "./report-constructor.module.scss"

const ReportConstructor = (props) => {

    return (
        <div className={s.ReportConstructor}>
            <ReportViewPage pageName={'pageName'}/>

            <ReportComponents 
                            reportComponents={props.reportComponents}
                            reportParameters={props.reportParameters}
                            getValue={props.getValue} 
                            fonts={props.fonts} 
                            colors={props.colors} 
                            fields={props.fields} 
                            selectedReport={props.selectedReport}
                            updateReportConstructor={props.updateReportConstructor}
                            setIsReportUpdated={props.setIsReportUpdated}
                            updateReportConstructorTemplateComponents={props.updateReportConstructorTemplateComponents}
                            textRepresentationList={props.textRepresentationList}
                            groupingTypeList={props.groupingTypeList}
                            includeTocList={props.includeTocList}
                            dateFields={props.dateFields}
                            documentElementsList={props.documentElementsList}
                            addNewComponent={props.addNewComponent}
                            addParameters={props.addParameters}
                            setIsReadOnly={props.setIsReadOnly}
                            isReadOnly={props.isReadOnly}
                            createdStatus={props.createdStatus}
                            updateTemplateComponents={props.updateTemplateComponents}
                            selectedLanguage={props.selectedLanguage}
                            feedSettings={props.feedSettings}
            />
        </div>
    )
}

export default ReportConstructor;